import { render, staticRenderFns } from "./SfCheckbox.vue?vue&type=template&id=18d4902c"
import script from "./SfCheckbox.vue?vue&type=script&lang=js"
export * from "./SfCheckbox.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfCheckbox.vue?vue&type=style&index=0&id=18d4902c&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "03b05d1c"
  
)

export default component.exports